import type { GetLatestArticlesByCategoryQuery } from '@seek/cmsu-cms-connect';
import React from 'react';
import { resizeImage } from '../../utils/resizeImage';

import { Card } from '../CardGroup/Card';

export type ArrayElement<ArrayType extends Array<any>> = ArrayType[number];

type Props = {
  article: ArrayElement<GetLatestArticlesByCategoryQuery['latestArticles']>;
};

export const ArticleCard = ({ article }: Props) => (
  <Card
    image={{ url: resizeImage(article?.featureImage[0]?.url, 480, 320) }}
    heading={{ level: 3, text: article.title }}
  />
);
